import { assoc, compose, flatten, is, isEmpty, map, pick, pipe, prop } from 'ramda'
import moment from 'moment'

import { formatAddressForApi } from './address'
import { formatApiDate } from './date'
import { hasValue } from './value'
import { isInterpolation } from './interpolation'
import { cleanStocksReplyRequest as cleanStocks } from '../../modules/stocks/bulkTransfer/_requests/cleanRequest'

const NO_VALUE = ' '

// TODO: Remove
export const clearDynamicValue = (value, valueType) => {
  switch (valueType) {
    case 'sign':
      return pick(['name', 'document', 'documentId'], value || {})

    case 'signature':
      return pick(['documentId'], value || {})

    case 'gallery':
      return map(pick(['documentId', 'description']), value || [])

    case 'pending':
      // TODO: Temp fix
      return undefined
    // return { ...reply, value: { pendingId: value } }

    case 'address':
    case 'location':
      const search = prop('search', value)
      if (!search) return undefined
      // TODO: Send full address and complement when api allows it
      return { search: value.search }

    case 'time':
      return undefined

    case 'datetime':
    case 'date':
      if (!value) return undefined
      let formatStr = 'DD-MM-YYYY'
      if (valueType === 'datetime') {
        formatStr += ' HH:mm'
      }
      return moment.utc(value).format(formatStr)

    case 'action_plan':
      return undefined

    default:
      return value
  }
}

export const cleanDynamicValueV2 = (value, valueType) => {
  let formattedValue = cleanValue(value, valueType)
  return formatJson(formattedValue, valueType)
}

const cleanSelectField = value => {
  if (value?.__typename === 'FieldOption') return JSON.stringify(value)

  return value?.reference || value?.id
}

export const cleanValue = (value, valueType) => {
  if (value === null) return null

  switch (valueType) {
    case 'select':
      return cleanSelectField(value)

    case 'multiple':
      if (!value || !value.length) return undefined
      return value.map(item => (is(Object, item) ? item?.reference || item?.id || item : item))

    case 'sign':
      return pick(['name', 'document', 'documentId'], value || {})

    case 'signature':
      return pick(['documentId'], value || {})

    case 'gallery':
      return map(
        compose(
          pick(['id', 'src', 'description', 'type', '__typename', 'documentId']), //
          item => assoc('documentId', item?.documentId || item?.id, item)
        ),
        value || []
      )

    case 'pending':
      if (!value) return undefined
      return { pendingId: value.pendingId }

    case 'user':
    case 'place':
    case 'asset':
      if (!hasValue(value)) return undefined

      if (is(Array, value)) {
        return value.map(prop('id'))
      } else {
        return value.id
      }

    case 'place_person':
    case 'place_location':
    case 'place_fleet':
      if (!hasValue(value)) return undefined
      return value.map(prop('id'))

    case 'location':
      const search = prop('search', value)
      if (!search) return undefined
      return formatAddressForApi(value)

    case 'time':
      return undefined

    case 'datetime':
      if (!value) return undefined
      return formatApiDate(value)

    case 'date':
      if (!value) return undefined
      if (isInterpolation(value)) return value

      return moment(value).format('YYYY-MM-DD')

    case 'action_plan':
      return cleanActionPlans(value || [])

    case 'block':
      if (!hasValue(value)) return undefined
      return value.length

    case 'stock':
      return cleanStockReplies(value)
    case 'integration':
      return JSON.stringify(value)

    case 'informative':
      return NO_VALUE

    default:
      return value
  }
}

const cleanStockReplies = value => {
  if (!value?.item?.id || !value.amount || !value?.operationType?.id) return
  const stock = cleanStocks(value)
  return stock
}

export const cleanActionPlans = map(item =>
  pipe(
    assoc('userId', item.userId || item.user?.id),
    assoc('groupId', item.groupId || item.group?.id),
    assoc('scheduling', formatApiDate(item.scheduling)),
    assoc('checklistId', item.checklistId || item.checklist?.id || item.service?.id),
    pick(['id', 'userId', 'groupId', 'checklistId', 'documents', 'description', 'scheduling'])
  )(item)
)

export const formatJson = (value, valueType) => {
  if (value === null) return null
  if (value === undefined || isEmpty(value)) return undefined

  switch (valueType) {
    case 'sign':
    case 'signature':
    case 'multiple':
    case 'location':
    case 'address':
    case 'gallery':
    case 'action_plan':
    case 'pending':
    case 'asset':
    case 'place_location':
    case 'place_person':
    case 'place_fleet':
    case 'stock':
    case 'place':
    case 'user':
      return JSON.stringify(value)

    default:
      return value
  }
}

export const getRepliesFromCategories = compose(flatten)
